/** Test packs from the schema suite. They are not personas for a live signup. */
export function isLiveModelId(id: string): boolean {
  const s = String(id || "").trim().toLowerCase();
  return Boolean(s) && !s.startsWith("schema_ok");
}

/** Pick the least-used model id; unused (count 0) preferred. Test packs are skipped. */
export function pickLeastUsedModelId(
  modelIds: string[],
  usedByAccounts: Array<string | null | undefined>,
): string | null {
  const ids = modelIds
    .map((id) => String(id || "").trim())
    .filter((id) => isLiveModelId(id));
  if (!ids.length) return null;
  const usage = new Map<string, number>(ids.map((id) => [id, 0]));
  for (const raw of usedByAccounts) {
    const id = String(raw || "").trim();
    if (id && usage.has(id)) usage.set(id, (usage.get(id) || 0) + 1);
  }
  let best = ids[0]!;
  let bestCount = usage.get(best) ?? 0;
  for (const id of ids.slice(1)) {
    const count = usage.get(id) ?? 0;
    if (count < bestCount) {
      best = id;
      bestCount = count;
    }
  }
  return best;
}
